import React from 'react'
import FormError from './FormError'

const FieldArrayTextAreaField = ({ field, form, error, ...props }) => {
  return (
    <div className="mb-6">
      <textarea
        {...field}
        {...props}
        className={`w-full py-4 px-6 text-lg rounded-lg bg-primary-lighter placeholder-black ${
          error ? 'border border-error' : 'border border-transparent'
        }`}
      />
      {error && <FormError error={error} />}
    </div>
  )
}

export default FieldArrayTextAreaField
